
console.log('Engine ready ⛰️');
gsap.registerPlugin(ScrollTrigger);

//hero home
function heroHome() {
  const heroHome = document.querySelector('.hero-home');
  if (heroHome) {

    const heroHome = document.querySelector('.hero-home');
    const videoContainer = heroHome.querySelector('.video-container');
    const videoElement = heroHome.querySelector('.video-player__video');
    const videoControls = heroHome.querySelector('.video-controls');
    const playButton = heroHome.querySelector('#play');
    const pauseButton = heroHome.querySelector('#pause');
    const volumeButton = heroHome.querySelector('#volume');
    const volumeOffButton = heroHome.querySelector('.volume-off');
    const volumeOnButton = heroHome.querySelector('.volume-on');
    const tl = gsap.timeline({ 
      repeat: -1
    });

    gsap.to(videoContainer, {
      clipPath: 'polygon(0% 0%,100% 0%,100% 100%,100% 100%,0% 100%,0% 100%)',
      duration: 1,
      scrollTrigger: {
        trigger: videoContainer,
        start: 'clamp(top center)',
        end: 'clamp(center center)',
        scrub: true,
        onLeave: () => {
          tl.pause();
          gsap.to(videoContainer.querySelector('.video-player'), {
            opacity: 1,
            pointerEvents: 'all',
            duration: 1,
            ease: 'power2.inOut'
          })
          gsap.to('.images-sprites',{opacity: 0, duration: 1, ease: 'power2.inOut'})
        },
        onEnterBack: () => {
          tl.play();
          gsap.to(videoContainer.querySelector('.video-player'), {
            opacity: 0,
            pointerEvents: 'none',
            duration: 1,
            ease: 'power2.inOut'
          })
          gsap.to('.images-sprites', { opacity: 1, duration: 1, ease: 'power2.inOut' })
          showHideControls(true)
        }
      },
    });

    playButton.addEventListener('click', () => {
      showHideControls(false)
    })
    pauseButton.addEventListener('click', () => {
      showHideControls(true)
    })

    volumeButton.addEventListener('click', () => {
      volumeOffButton.classList.toggle('hidden');
      volumeOnButton.classList.toggle('hidden');
      videoElement.muted = !videoElement.muted;
    })

    const showHideControls = (pause) => {
      if (pause) { 
        videoElement.pause();
        gsap.set(playButton, { opacity: 1 })
        gsap.to('.active-progress', {
                opacity: 0,
                pointerEvents: 'all',
            duration: 0.5,
            ease: 'power2.inOut'
          })
      } else {
        videoElement.play();
        gsap.set(playButton, { opacity: 0 })
        gsap.set('.active-progress', {
            opacity: 1,
            pointerEvents: 'all',
          })
      }
      videoControls.classList.toggle('playing', !pause)
          
    }

    const posterVideos = videoContainer.querySelectorAll('.poster-video');
    gsap.set(posterVideos, { 
      opacity: 0,
      position: 'absolute'
    });
    gsap.set(posterVideos[0], { 
      opacity: 1,
      position: 'relative'
    });

    // Aggiungi le transizioni
    posterVideos.forEach((img, index) => {
      const nextIndex = (index + 1) % posterVideos.length;
      const nextImg = posterVideos[nextIndex];
      
      tl.to({}, { duration: 0.5 }) // Pausa
        .set(img, { position: 'absolute' })
        .set(nextImg, { position: 'relative' }) // Imposta next come relative PRIMA del fade
        .to(img, {
          opacity: 0, // img fade out, nextImg fade in
          duration: 0.8,
          ease: "power2.inOut"
        })
        
        .to(nextImg, {
          opacity: 1, // img fade out, nextImg fade in
          duration: 0.8,
          ease: "power2.inOut"
        }, '<')
        
    });

  }
}

//section sticky tabs
function sectionStickyTabs() {
  const sectionStickyTabs = document.querySelector('.section-sticky-tabs');
  if (!sectionStickyTabs) return;

  const tabsWrap = sectionStickyTabs.querySelector('.tabs-wrap');
  const asideWrap = tabsWrap.querySelector('.aside-wrap');
  const tabs = asideWrap.querySelectorAll('.tab-item');
  const panelsWrap = sectionStickyTabs.querySelector('.panels-wrap');
  const panels = panelsWrap.querySelectorAll('.panel-item');
  const scroller = panelsWrap.querySelector('.panels-scroller');

  let maxHeight = 0;
  let introTabs = sectionStickyTabs.querySelector('.intro-tabs');
  let introTabsHeight = introTabs.offsetHeight;

  tabs[0].classList.add('active');
  panels[0].classList.add('active');

  function resizePanels() {
    maxHeight = 0;
    panels.forEach(panel => {
      const h = panel.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });
    introTabsHeight = introTabs.offsetHeight;
    gsap.set('.panel-item', { height: maxHeight });
    gsap.set(asideWrap, { top: `${window.innerWidth > 767 ? introTabsHeight : 0}px`  });
  }

  resizePanels();

  const setActive = (index) => {
    const prevSelected = document.querySelector('.tab-item.active');
    if(prevSelected){
      prevSelected.classList.remove('active');
    }
    tabs.forEach((el, i) => {
      el.classList.toggle('active', i === index)
    });
  };
  tabs.forEach((el, i) => {
    el.addEventListener('click', () => {
      const scrollHeight = window.innerWidth > 767 ?  window.pageYOffset - introTabsHeight :  window.pageYOffset - asideWrap.clientHeight;

      window.scrollTo({
        top: panels[i].getBoundingClientRect().top + scrollHeight,
        behavior: 'smooth'
      });
    });
  });
  
  panels.forEach((el, i) => {
    ScrollTrigger.create({
      trigger: el,
      start: window.innerWidth > 767 ? 'top center' : `top center`,
      end: `bottom top+=${introTabsHeight}px`,
      scrub: true,
      onEnter: () => {
        setActive(i);
      },
      onEnterBack: () => {
        setActive(i);
      },
    }); 
  });
}

//modal contact
function modalContact() { 
  let modalContactCta = document.querySelectorAll('[data-modal="contact"]');
  let modalContact = document.querySelector('.modal-contact');

  console.log(modalContactCta);


  if (modalContactCta.length > 0 && modalContact) {
    let modalContactInner = modalContact.querySelector('.col-main');
    let body = document.body;

    // Funzione per chiudere il modale
    function closeModal() {
      modalContact.classList.remove('active');
      body.classList.remove('overflow-hidden');
    }

    // modale
    modalContactCta.forEach(cta => {
      cta.addEventListener('click', (e) => {
        e.preventDefault();

        modalContact.classList.add('active');
        body.classList.add('overflow-hidden');

        const selectedReason = cta.getAttribute('data-reason');

        setTimeout(() => {
          const select = document.querySelector('select[name="reason"]');
          if (select && selectedReason) {
            select.value = selectedReason;

            const event = new Event('change', { bubbles: true });
            select.dispatchEvent(event);
          }
        }, 100);
      });
    });

    modalContact.addEventListener('click', function(e) {
      if (!modalContactInner.contains(e.target)) {
        closeModal();
      }
    });
    const closeButton = modalContact.querySelectorAll('.close-overlay');
    closeButton.forEach(button => {
      button.addEventListener('click', () => {
        closeModal();
      });
    });
    //modal redirect
    document.addEventListener( 'wpcf7mailsent', function( event ) {
      location = '/thank-you/';
    });
  }
}

//section press list
function sectionPressList() {
  const pressLists = document.querySelectorAll('.section-press-list .list-wrap');

  if (!pressLists.length) return;

  pressLists.forEach((pressList) => {
    const cards = Array.from(pressList.querySelectorAll('.press-card'));
    const loadMoreButton = pressList.querySelector('.load-more-btn');

    if (!cards.length) {
      if (loadMoreButton) {
        loadMoreButton.classList.add('is-hidden');
      }
      return;
    }

    const initialVisibleIndex = Number(pressList.dataset.visibleIndex) || 4;
    const step = loadMoreButton ? (Number(loadMoreButton.dataset.step) || 5) : 5;
    let visibleIndex = Math.min(initialVisibleIndex, cards.length - 1);

    const updateVisibility = () => {
      cards.forEach((card, index) => {
        card.classList.toggle('is-hidden', index > visibleIndex);
      });

      if (loadMoreButton) {
        const hasHiddenCards = cards.some((card) => card.classList.contains('is-hidden'));
        loadMoreButton.classList.toggle('is-hidden', !hasHiddenCards);
      }
    };

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        visibleIndex = Math.min(visibleIndex + step, cards.length - 1);
        updateVisibility();
      });
    }

    updateVisibility();
  });
}

heroHome();
sectionStickyTabs();
modalContact();
sectionPressList();
